import template from "./bProjects.html";
import moment from "moment";

import { countryProjectsStore } from "../pCountry/countryProjects.store";

export function bProjectsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bProjectsController,
    controllerAs: 'bProjects',
    bindToController: true,
    scope: {
      selectedClient: "=",
      canSetProjectsManually: "=",
      canSeeProjectsFromErp: "=",
      archived: "=",
    },
  };

  return directive;
}

class bProjectsController {
  constructor(Notes, bModal, $translate) {
    'ngInject';

    this.Notes = Notes;
    this.bModal = bModal;
    this.$translate = $translate;

    this.projectsStore = countryProjectsStore;

    this.projectsHeaders = [
      {name: this.$translate.instant("PROJECTS.TEXT_ID"), class: "table-info-short", sort:"projectTextId"},
      {name: this.$translate.instant("PROJECTS.NAME"), class: "table-info", sort:"name"},
      {name: this.$translate.instant("PROJECTS.FROM_DATE"), class: "table-date", sort:"validFrom"},
      {name: this.$translate.instant("PROJECTS.TO_DATE"), class: "table-date", sort:"validUntil"},
      {name: this.$translate.instant("PROJECTS.NO_EXPIRATION_DATE_SHORT"), class: "table-short"},
      {id: "actions", name: null, class: "table-actions"},
    ];

    this.projectsHeadersErp = this.projectsHeaders.filter(h => h.id !== "actions");

  }

  projectsByState(archived) {
    if (archived) {
      return this.projectsStore.archivedProjects;
    }
    else return this.projectsStore.activeProjects;
  }

  addNewProject(client) {
    if (this.selectedClient != client) return;
    this.disabledAddNewProject = true;

    const newProject = {
      new: true,
      projectTextId: "",
      name: "",
      validFrom: moment().format("YYYY-MM-DD"),
      validUntil: moment().format("YYYY-MM-DD"),
      noExpirationDate: true,
      status: "Active"
    };

    this.projectsStore.addNewProject(newProject);
  }

  archiveProject(project) {
    this.modalConfig = {
      text: "PROJECTS.ARCHIVE_CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "ARCHIVE"
    };

    if (!project.id) { this.setProjectIdAfterCreation(project); }

    this.bModal.show(this.modalConfig).then(() => {
      project.saving = true;
      this.projectsStore.archiveProject(project).catch((error) => {
        this.Notes.postNote({ type: "error", error: error });
      });
    }, angular.noop);
  }

  restoreProject(project) {
    this.modalConfig = {
      text: "ARCHIVED_PROJECTS.RESTORE_CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "RESTORE"
    };

    this.bModal.show(this.modalConfig).then(() => {
      project.saving = true;
      this.projectsStore.restoreProject(project).catch(error => {
        this.Notes.postNote({ type: "error", error: error });
      });
    }, angular.noop);
  }

  cancelAddingNewProject(project) {
    this.projectsStore.cancelAddingNewProject(project);
    this.disabledAddNewProject = false;
  }

  setProjectIdAfterCreation(project) {
    const projectsLength = this.projectsStore.projects.length;
    project.id = this.projectsStore.projects.find(pr => pr.projectTextId == project.projectTextId && this.projects.indexOf(pr) == projectsLength - 1).id;
  }

  startEditingProject(project) {
    const today = moment().format("YYYY-MM-DD");

    if (!project.id) { this.setProjectIdAfterCreation(project); }
    project.previousVersion = angular.copy(project);
    project.edited = true;
    const newProject = {
      projectTextId: project.projectTextId,
      name: project.name,
      validFrom: project.validFrom || today,
      validUntil: project.validUntil || (moment(project.validFrom).unix() > moment().unix() ? project.validFrom : today),
      noExpirationDate: project.noExpirationDate
    };
    if (project.noExpirationDate == true) delete project.validUntil;

    angular.extend(project, newProject);
  }

  cancelEditingProject(project) {
    angular.extend(project, project.previousVersion);
    project.edited = false;
    project.error = false;
    if (project.noExpirationDate == true) delete project.validUntil;
    delete project.previousVersion;
  }

  saveNewProject(project) {
    this.projectsStore.saveNewProject(project, this.selectedClient.id).catch( error => {
      this.Notes.postNote({ type: "error", error: error });
    });
    this.disabledAddNewProject = false;
    this.selectedClient.hasProjects = this.projectsStore.hasProjects;
  }

  saveEditedProject(project) {
    this.projectsStore.saveEditedProject(project).catch(error => {
      this.Notes.postNote({ type: "error", error: error });
    });
  }

  updateDate(project, param) {
    let dateStart = moment(project.validFrom);
    let dateEnd = moment(project.validUntil);

    if(dateEnd.unix() < dateStart.unix()) {
      if( param === "start" ){
        dateEnd = dateStart;
        project.validUntil = dateEnd.format("YYYY-MM-DD");
      }
      if( param == "end" ){
        dateStart = dateEnd;
        project.validFrom = dateEnd.format("YYYY-MM-DD");
      }
    }
  }
}
